import { type ColorTheme, colorThemeSchema } from "@shelflist/shared";
import { useQuery } from "@tanstack/react-query";
import { useLayoutEffect } from "react";
import { meQuery } from "./queries";

/** The account preference is authoritative; anonymous pages use the original palette. */
export function applyColorTheme(theme?: ColorTheme | null) {
  document.documentElement.dataset.colorTheme = colorThemeSchema.safeParse(theme).data ?? "teal";
}

/** Read the actual session cache, never the route's fallback user during sign-out. */
export function useAccountColorTheme() {
  const { data } = useQuery(meQuery);
  useLayoutEffect(() => applyColorTheme(data?.colorTheme), [data?.colorTheme]);
}
